import ItemBasedScrolling from './item-based';
import PageBasedScrolling from './page-based';
import { PREVIOUS, NEXT } from './direction';

export {
  ItemBasedScrolling,
  PageBasedScrolling,
};
/**
 * This class manages scrolling algorithms and exposes
 * methods to navigate a carousel with "previous" and "next" buttons
 */
export default class CarouselController {
  constructor({ container, items, algorithm = new ItemBasedScrolling() } = {}) {
    this.container = container;
    this.items = items;
    this.algorithm = algorithm;
  }

  previous(currentPosition) {
    this.algorithm.scroll(this.container, this.items, currentPosition, PREVIOUS);
  }

  next(currentPosition) {
    this.algorithm.scroll(this.container, this.items, currentPosition, NEXT);
  }
}
